import React from 'react'
import { Skeleton, Box } from '@mui/material'
import { postSubmit } from '@ui-seeker/utils'

import { TitleWithPopover, ActionButton, AppTableSeeker } from '@components'
import { BACKEND_APIS } from '@constants'
import { useToast } from '@hooks'
import { idColumn, actionsColumn, skusColumn, customerColumn, usersColumn } from './columns'
import { useSkuGroupTableFilters } from './@hooks'
import { skuGroupDrawerFilters, reloadSkuGroupFilters } from '../@signals'


export default function SkuGroupTable() {
    const { data, isLoading } = useSkuGroupTableFilters()
    const { showToast } = useToast()

    const handleDelete = (row) => {
        showToast.confirm(`Delete SKU group "${row.name}"?`, {
            onSubmit: () => showToast.promise(
                postSubmit(`${BACKEND_APIS.MANAGEMENT}/sku-group/delete`, { skuGroupID: row.skuGroupID })
                    .then(() => { reloadSkuGroupFilters.value += 1 })
            )
        })
    }

    if (isLoading) return <Skeleton variant="rectangular" height={500} />
    if (!data.length) return <></>

    const columns = [
        idColumn(),
        actionsColumn(handleDelete),
        skusColumn(),
        customerColumn(),
        usersColumn(),
    ]

    return <AppTableSeeker
        data={data}
        title={<TitleWithPopover title="SKU Groups" />}
        columns={columns}
        options={{
            viewColumns: false,
            customToolbar: () => (
                <Box display="flex" gap={2}>
                    <ActionButton
                        label="Create SKU Group"
                        icon="hexagon-plus"
                        onClick={() => { skuGroupDrawerFilters.value = { mode: 'create' } }}
                    />
                </Box>
            )
        }}
    />
}
